import AbstractEntity from "../AbstractEntity";

export default class RequestedDocument extends AbstractEntity {
    static STATUS_REQUESTED = 0;
    static STATUS_PROVIDED = 1;
    static STATUS_ACCEPTED = 2;
    static STATUS_REFUSED = 3;
    static STATUS_UNNECESSARY = 4;

    static CLIENT_PRICE_CERTIFICATE_NAME = "Attestation de RAC de {price}";
    static CLIENT_PRICE_INVOICE_NAME = "Facture de reste à charge sociétaire";
    static DELIVERY_CERTIFICATE_NAME = "Procès-Verbal de fin d'intervention";

    _id;
    _name;
    _documentId;
    _status;
    _refusedReason;
    _signatureId;
    _createdAt;
    _interventionId;


    getId() {
        return this._id;
    }

    getName() {
        return this._name;
    }

    getDocumentId() {
        return this._documentId;
    }

    getStatus() {
        return this._status;
    }

    getRefusedReason() {
        return this._refusedReason;
    }

    getSignatureId() {
        return this._signatureId;
    }

    getCreatedAt() {
        return this._createdAt;
    }

    getInterventionId() {
        return this._interventionId;
    }

    getClassName() {
        return "requested_document";
    }
}